"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
const styled_components_1 = require("styled-components");
const styled_system_1 = require("styled-system");
const fill = (0, styled_system_1.style)({ prop: "fill", cssProperty: "color", key: "colors" });
;
exports.Box = styled_components_1.default.div(styled_system_1.flexbox, styled_system_1.layout, styled_system_1.position, styled_system_1.space, styled_system_1.color, fill);
//# sourceMappingURL=Box.js.map